import type z from '@/lib/zod';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/** Filtri delle commissioni: la stessa pagina di `/admin` e `/referrer`. */
export const commissionsSearchSchema = commonSearchSchema.extend({
  /** Tab dello stato (come la webapp): prima era uno stato in memoria. */
  subTab: optionalSearchString(),
  referrerId: optionalSearchString(),
  tenantId: optionalSearchString(),
  isFirstPurchase: optionalSearchString(),
});

export type CommissionsSearch = z.output<typeof commissionsSearchSchema>;
